module.exports = __webpack_public_path__ + "static/img/6.7f53db51.png";